import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';
import Login from './components/auth/Login';
import TwitchCallback from './components/auth/TwitchCallback';
import Dashboard from './components/dashboard/Dashboard';
import AdminPortal from './components/admin/AdminPortal';
import LanguageSwitcher from './components/LanguageSwitcher';
import { formatters } from './utils/dateUtils';
import './i18n';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/auth/twitch/callback" element={<TwitchCallback />} />
            <Route 
              path="/dashboard" 
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              } 
            />
            <Route 
              path="/admin" 
              element={
                <PrivateRoute>
                  <AdminPortal />
                </PrivateRoute>
              } 
            />
          </Routes>
          <footer className="app-footer">
            <div className="footer-content">
              <div className="footer-left">
                <span className="footer-brand">StreamQuest, {formatters.currentYear()}</span>
                <div className="footer-tech-info">
                  <span className="node-version">
                    v{process.env.REACT_APP_VERSION?.replace('v', '')}
                  </span>
                </div>
              </div>
              <div className="footer-right">
                <LanguageSwitcher />
              </div>
            </div>
          </footer>
          <Toaster 
            theme="dark"
            toastOptions={{
              className: 'sonner-toast',
            }}
            closeButton
            position="bottom-right"
          />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App; 